import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import { EloButton } from '@elo-kit/components/elo-button/EloButton'
import { useI18n } from '@elo-kit/components/i18n/i18n'

export const EmptyContent = React.memo((props) => {
  const I18n = useI18n()
  const {
    fileUrl,
    locales = {
      docIsNotVisibleTitle: I18n.t('react.shared.pdf_errors.title'),
      docIsNotVisibleContent: I18n.t('react.shared.pdf_errors.content'),
      docIsNotVisibleBtnContent: I18n.t('react.shared.pdf_errors.button'),
      renderPaginationInfo: (localeProps) => I18n.t('react.shared.num_of', localeProps),
    },
    classes,
  } = props

  return (
    <div className={classNames('no-data-message', classes.noDateMessage)}>
      <div className='error-header'>
        <i className='fas fa-exclamation-triangle' />
        <span className='error-header-text'>{locales.docIsNotVisibleTitle}</span>
      </div>
      <div className='error-content'>{locales.docIsNotVisibleContent}</div>
      <EloButton href={fileUrl} downloadOnClick target='_blank'>
        {locales.docIsNotVisibleBtnContent}
      </EloButton>
    </div>
  )
})

EmptyContent.propTypes = {
  fileUrl: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  classes: PropTypes.object,
  locales: PropTypes.shape({
    docIsNotVisibleTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    docIsNotVisibleContent: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    docIsNotVisibleBtnContent: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    renderPaginationInfo: PropTypes.func,
  }),
}

EmptyContent.defaultProps = {
  fileUrl: '',
  classes: {},
}
